/** @format */

import React, { useState, useContext, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { Context } from "../stores/Provider";
import { PostMethod } from "../api/Api";
import { mailValidate, singlePasswordValidate } from "../validators/publicValidator";
import { getSession, setSession } from "../sessionStorage/sessionStorageMethod";
import { setSessionAllData, setIsLoading, browserBackBan } from "../function";
import { initApiResponse, zAccountNameObj } from "../constance/constance";
import {
  initApiResponseType,
  successApiResponseType,
  errorApiResponseType,
  loginRequestType,
  loginResponseType,
} from "../@types";

const useLoginHooks = (navigateByAgent: Function) => {
  const location = useLocation();
  const { state, dispatch } = useContext(Context);
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [errMsgs, setErrMsgs] = useState<{
    email: string;
    password: string;
  }>({
    email: "",
    password: "",
  });

  const loginInfoData = getSession("login");

  const zAccount = useMemo(() => state.zAccount, [state.zAccount]);
  const zAccountName = useMemo(() => zAccountNameObj[state.zAccount], [state.zAccount]);

  useEffect(() => {
    if (loginInfoData !== null && loginInfoData.code === 200) return;
    setSessionAllData();
    //認証ページから遷移の場合のみブラウザバック禁止
    if (location.state === null || location.state.routeTo.split("/").slice(-1)[0] !== "login") return;
    browserBackBan();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const LoginMethod = async () => {
    let loginResponse: initApiResponseType = initApiResponse;
    setErrMsgs({ email: "", password: "" });

    const validateMail = mailValidate(email);
    const validatePassword = singlePasswordValidate(password);
    if (!validateMail.isValidate || !validatePassword.isValidate) {
      setErrMsgs({
        email: validateMail.message,
        password: validatePassword.message,
      });
      return loginResponse;
    }

    const loginData: loginRequestType = {
      email: email,
      password: password,
      z_account: zAccount,
    };

    setIsLoading(true, dispatch);
    loginResponse = await PostMethod<loginRequestType, loginResponseType>(loginData, "/login");
    return loginResponse;
  };

  const normal = (response: successApiResponseType<loginResponseType>) => {
    setSession("user", {
      ...getSession("user"),
      email: email,
      user_id: response.response_data.user_id,
    });
    setSession("login", {
      ...getSession("login"),
      err_message: "",
      code: response.code,
    });
    return navigateByAgent("/entry_select");
  };

  const abnormal = (response: errorApiResponseType) => {
    setSession("login", {
      err_message: response.message,
      code: response.code,
    });
    return navigateByAgent("/login");
  };

  const setPasswordHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    return setPassword(e.target.value);
  };

  const setEmailHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    return setEmail(e.target.value);
  };

  return {
    errMsgs,
    zAccountName,
    zAccount,
    LoginMethod,
    normal,
    abnormal,
    setPasswordHandler,
    setEmailHandler,
  };
};

export default useLoginHooks;
